import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Método que obtiene todos los epp del sistema.
 *
 * @param {*} param0
 */
export async function getJsonEpp({commit, state}) {

    await $http.get('productos/JsonEpp/ver')
        .then((response) => {
            commit('cargarJsonEpp', response.data)
            ;
        })
        .catch((error) => {

        });

}

/**
 * Métpdo para obtener los epp de un producto químico.
 *
 * @param {*} param0
 */
export async function getEpp({commit, state, rootState}) {

    var producto = rootState.productos.selectedProduct.id;
    commit('dashboard/load', true, {root: true});
    await $http.get(`adm_productos/epp/ver/${producto}`, state.selectedEpp)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('cargarEpp', response.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Métpdo para obtener los epp de un producto químico con descripciones.
 *
 * @param {*} param0
 */
export async function getEppDescripcion({commit, state, rootState}) {

    var producto = rootState.productos.selectedProduct.id;
    await $http.get(`adm_productos/epp/ver_descripcion/${producto}`, state.selectedEpp)
        .then((response) => {
            commit('cargarEpp', response.data)
            ;
        })
        .catch((error) => {

        });
}

/**
 * Método para obtener los epp descritos de un producto químico.
 *
 * @param {*} param0
 */
export async function getDescritoEpps({commit, state, rootState}) {

    var producto = rootState.productos.selectedProduct.id;
    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }
    await $http.get(`adm_productos/epp/descrito/ver/${producto}`, {params: state.filtro})
        .then(async (response) => {

            if (response.data.data) {
                state.selectedEpp.bocular = response.data.data.ocular ? true : false;
                state.selectedEpp.bcutanea = response.data.data.cutanea ? true : false;
                state.selectedEpp.brespiratoria = response.data.data.respiratoria ? true : false;
                state.selectedEpp.bcalzado = response.data.data.calzado ? true : false;
                state.selectedEpp.bropa = response.data.data.ropa ? true : false;
            } else {
                state.selectedEpp.bocular = false;
                state.selectedEpp.bcutanea = false;
                state.selectedEpp.brespiratoria = false;
                state.selectedEpp.bcalzado = false;
                state.selectedEpp.bropa = false;
            }
            commit('cargarEppDescritos', response.data);
        })
        .catch((error) => {

        });
}

/**
 * Método para guardar los epp de un producto químico.
 *
 * @param Object vuex
 * @param Integer productId
 */
export async function guardaEpp({dispatch, state, rootState, commit}, productId = null) {

    if (!productId) {
        var producto = rootState.productos.selectedProduct.id;
        if (producto == '') {
            producto = rootState.productos.selectedProduct.Idproducto;
        }
    } else producto = productId

    commit('dashboard/load', true, {root: true});

    await $http.post(`adm_productos/epp/crear/${producto}`, state.selectedEpp)
        .then(async (response) => {
            if (productId) return;

            await dispatch('getEpp');
            await dispatch('guardaIcosEpp', producto);
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });

            if (rootState.productos.producto_nuevo) {
                commit('productos/setTabActivo', 6, {root: true});
            }
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para guardar los epp descritos de un producto químico.
 *
 * @param {*} param0
 * @param {*} tipo cotiene el tipo de epp descrito.
 */
export async function guardaEppDescrito({commit, dispatch, state, rootState}) {

    let producto = rootState.productos.selectedProduct.id;
    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }
    await $http.post(`adm_productos/epp/descrito/crear/${producto}`, state.selectedEpp)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });
            await dispatch('getDescritoEpps');
            commit('limpiarCreacionEpp');
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para actualizar los epp descritos.
 *
 * @param {*} param0
 * @param {*} epp contiene la información del epp descrito.
 */
export async function actualizaEppDescrito({dispatch, state, rootState}) {
    var producto = rootState.productos.selectedProduct.id;
    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }
    await $http.put(`adm_productos/epp/descrito/editar/${producto}`, state.selectedEpp)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });
            await dispatch('getDescritoEpps');
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para elimar un epp descrito.
 *
 * @param {*} param0
 * @param {*} epp contiene la información del epp descrito.
 */
export async function eliminaEppDescrito({commit, dispatch, state, rootState}, epp) {

    var producto = rootState.productos.selectedProduct.id;
    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }
    await $http.post(`adm_productos/eppdescrito/inactivar/${producto}`, epp)
        .then(async (response) => {
            if (state.mensajeEliminado) {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                });
            }

            if (state.selectedEpp.lista.length === 1 && state.filtro.page > 1) {
                commit('setPage', 1);
            }
            await dispatch('getDescritoEpps');
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para guardar los epp icos.
 *
 * @param {*} param0
 * @param {*} data contiene la información de los epp.
 */
export async function guardaIcosEpp({dispatch, state, rootState, commit}, id_producto) {

    //    $api->post('adm_productos/eppicos/crear/{id}', 'App\Http\Controllers\ApiCore\Productos\Epps\ProdEppController@storeEppIcos');
    commit('dashboard/load', true, {root: true});
    await $http.post(`adm_productos/eppicos/crear/${id_producto}`, {iconos: state.selectedEppIcos})
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });
            await dispatch('getEppIcos');
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para obtener los epp icos del producto.
 *
 * @param {*} param0
 */
export async function getEppIcos({commit, state, rootState}) {

    var producto = rootState.productos.selectedProduct.id;
    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }

    commit('dashboard/load', true, {root: true});
    await $http.get(`adm_productos/eppicos/ver/${producto}`, state.selectedEppIcos)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('cargarEppIcos', response.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Método para obtener los epp icos en la sesion de empresa.
 *
 * @param {*} param0
 */
export async function getEppIcosEmpresa({commit, state, rootState}) {
    var producto = rootState.productos.selectedProduct.id;
    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }
    await $http.get(`adm_productos/eppicos/ver/${producto}`, state.selectedEpp)
        .then((response) => {
            commit('cargarEppIcosEmpre', response.data);
        })
        .catch((error) => {

        });
}

/**
 * Método para obtener los epp de un producto en la sesion empresa
 *
 * @param {*} param0
 */
export async function getEppEmpresa({commit, state, rootState}) {

    var producto = rootState.productos.selectedProduct.id;
    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }
    await $http.get(`adm_productos/eppEmpresa/ver/${producto}`, state.selectedEpp)
        .then((response) => {

            commit('cargarEppEmpresa', response.data);
        })
        .catch((error) => {

        });
}
